import React from "react";

const HazardAudit = () => {
  return <> {/* Your existing audit content */}</>;
};

export default HazardAudit;
